module.exports = __webpack_public_path__ + "static/img/cdms_logo.6bc84f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cdms_logo.png
// module id = aRSA
// module chunks = 109